import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clientesApi } from '@/lib/api';
import type { Cliente } from '@/types';

export function useClientes(params?: any) {
  return useQuery({
    queryKey: ['clientes', params],
    queryFn: async () => {
      const response = await clientesApi.listar(params);
      const data = response.data;
      if (data && typeof data === 'object' && 'data' in data && Array.isArray(data.data)) {
        return data.data as Cliente[];
      }
      return (Array.isArray(data) ? data : []) as Cliente[];
    },
  });
}

export function useCliente(id: string) {
  return useQuery({
    queryKey: ['cliente', id],
    queryFn: async () => {
      const response = await clientesApi.buscar(id);
      return response.data as Cliente;
    },
    enabled: !!id,
  });
}

export function useDeletarCliente() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => clientesApi.deletar(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientes'] });
    },
  });
}

export function useBulkDeletarClientes() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (ids: string[]) => clientesApi.bulkDeletar(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientes'] });
    },
  });
}
